import type { BillingUsage } from './types'

/** The billing summary as CSV: formatting only, every figure comes from the API. */
const csvCell = (v: unknown) => {
  const s = v == null ? '' : String(v)
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}
const csv = (rows: unknown[][]) => `﻿${rows.map((r) => r.map(csvCell).join(',')).join('\n')}\n`

/** One organisation's summary: a metric per row, then the months. */
export function oneCsv(u: BillingUsage): string {
  const rows: unknown[][] = [
    ['organisation', u.organisation], ['tier', u.subscription?.tier ?? ''],
    ['period_from', u.period.from], ['period_to', u.period.to], [],
    ['metric', 'value', 'allowance', 'used_pct'],
    ['suppliers_in_scope', u.suppliers.inScope, u.suppliers.allowance ?? '', u.suppliers.usedPct ?? ''],
    ['unique_hectares_verified', u.hectares.uniqueVerified, u.hectares.allowance ?? '', u.hectares.usedPct ?? ''],
    ['seats', u.users.seats, u.users.allowance ?? '', u.users.usedPct ?? ''],
    ['parent_groups_in_scope', u.suppliers.parentGroups], ['materials_in_scope', u.suppliers.materials],
    ['campaigns_open', u.suppliers.campaignsOpen],
    ['unique_plots_verified', u.hectares.uniquePlots], ['plot_checks', u.hectares.plotChecks], ['check_runs', u.hectares.checkRuns],
    ['uploads', u.hectares.uploads], ['uploaded_hectares', u.hectares.uploadedHa],
    ['stored_plots_now', u.hectares.storedPlots], ['stored_hectares_now', u.hectares.storedHa],
    ['active_staff', u.users.activeStaff], ['supplier_logins', u.users.supplierLogins],
    ['active_supplier_logins', u.users.activeSupplierLogins], ['active_suppliers', u.users.activeSupplierCompanies],
    ['campaigns_opened', u.activity.campaignsOpened], ['submissions_submitted', u.activity.submissionsSubmitted],
    ['submissions_approved', u.activity.submissionsApproved], ['exports', u.activity.exports],
    ['scenario_runs', u.activity.scenarioRuns], ['emails_sent', u.activity.emailsSent],
    ['token_api_requests', u.activity.tokenRequests], ['sourcing_api_requests', u.activity.sourcingApiRequests],
    ['document_storage_gb_now', u.activity.documentStorageGb],
  ]
  if (u.monthly?.length) {
    rows.push([], ['month', 'unique_hectares', 'unique_plots', 'suppliers_in_scope', 'active_suppliers', 'active_staff'])
    for (const m of u.monthly) rows.push([m.month, m.uniqueHectares, m.uniquePlots, m.suppliersInScope, m.activeSupplierCompanies, m.activeStaff])
  }
  return csv(rows)
}

/** Every organisation: one row each. */
export function allCsv(items: BillingUsage[]): string {
  return csv([
    ['organisation', 'tier', 'period_from', 'period_to', 'suppliers_in_scope', 'suppliers_allowance', 'unique_hectares_verified',
      'hectares_allowance', 'seats', 'seats_allowance', 'active_suppliers', 'active_staff', 'stored_hectares_now'],
    ...items.map((u) => [
      u.organisation, u.subscription?.tier ?? '', u.period.from, u.period.to, u.suppliers.inScope, u.suppliers.allowance ?? '',
      u.hectares.uniqueVerified, u.hectares.allowance ?? '', u.users.seats, u.users.allowance ?? '',
      u.users.activeSupplierCompanies, u.users.activeStaff, u.hectares.storedHa,
    ]),
  ])
}
